module.exports = __webpack_public_path__ + "static/flags/SU-63baf9d445f60ca37edb00fe19fadd84.gif";